import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Carousel, CarouselControls, CarouselNavigation, CarouselPagination, CarouselSlide } from "@cinch-nx/shared-ui";
import Image from "next/legacy/image";
import styles from "./image-carousel.module.css";
const carouselSettings = {
    name: "partnerships-images",
    ariaLabels: {
        previous: "Go to previous slide",
        next: "Go to next slide"
    },
    swiperSettings: {
        spaceBetween: 0,
        slidesPerView: 1
    }
};
const ImageCarousel = ({ images  })=>{
    var ref;
    /*#__PURE__*/ return _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Carousel, {
                name: carouselSettings.name,
                swiperSettings: carouselSettings.swiperSettings,
                customClassNames: {
                    carousel: styles.carousel
                },
                children: (ref = images.filter((image)=>{
                    return image === null || image === void 0 ? void 0 : image.filename;
                })) === null || ref === void 0 ? void 0 : ref.map((image, idx)=>/*#__PURE__*/ _jsx(CarouselSlide, {
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.imageWrapper,
                            children: /*#__PURE__*/ _jsx(Image, {
                                src: image.filename,
                                alt: image.alt ?? undefined,
                                layout: "fill",
                                objectPosition: "40%",
                                objectFit: "cover",
                                // This is a full width image and therefore the largest contentful paint LCP.
                                // Eagerly load the first image and lazy load the others.
                                priority: idx === 0
                            })
                        })
                    }, image.id))
            }),
            /*#__PURE__*/ _jsxs(CarouselControls, {
                customClassNames: styles.carouselControls,
                children: [
                    /*#__PURE__*/ _jsx(CarouselPagination, {
                        name: carouselSettings.name
                    }),
                    /*#__PURE__*/ _jsx(CarouselNavigation, {
                        name: carouselSettings.name,
                        ariaLabels: carouselSettings.ariaLabels,
                        customClassNames: {
                            prevButton: styles.carouselNavButton,
                            nextButton: styles.carouselNavButton
                        }
                    })
                ]
            })
        ]
    });
};
export default ImageCarousel;
